import React, { Component } from 'react'
import { Formik } from 'formik'

import { TextField } from '@material-ui/core'
import { Link, Redirect } from 'react-router-dom'

import * as AuthService from 'services/auth.service'

class ForgotPassword extends Component {
  state = { isRequested: false }

  render() {
    const { isRequested } = this.state

    if (isRequested) {
      return <Redirect to='/auth' />
    }

    return (
      <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
        <div className='kt-login__body'>
          <div className='kt-login__form'>
            <div className='kt-login__title'>
              <span>RECUPERAR CONTRASEÑA</span>
            </div>

            <Formik
              initialValues={{ email: '' }}
              onSubmit={(values, { setStatus, setSubmitting }) => {
                AuthService.solicitarCambioContrasena(values)
                  .then(() => {
                    this.setState({ isRequested: true })
                  })
                  .catch(() => {
                    setSubmitting(false)
                    setStatus('No se ha encontrado el correo ingresado.')
                  })
              }}
            >
              {({
                values,
                status,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
              }) => (
                <form onSubmit={handleSubmit} className='kt-form'>
                  {status && (
                    <div role='alert' className='alert alert-danger'>
                      <div className='alert-text'>{status}</div>
                    </div>
                  )}

                  <div className='form-group'>
                    <TextField
                      type='email'
                      label='Email'
                      margin='normal'
                      fullWidth={true}
                      name='email'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.email}
                      helperText={touched.email && errors.email}
                      error={Boolean(touched.email && errors.email)}
                    />
                  </div>
                  <div style={{ height: 90, width: "100%" }}></div>
                  <div className='kt-login__actions'>
                    <Link to='/auth'>
                      <button
                        type='button'
                        className='btn btn-secondary btn-elevate kt-login__btn-secondary'
                      >
                        Cancelar
                      </button>
                    </Link>

                    <button
                      type='submit'
                      className='btn btn-primary btn-elevate kt-login__btn-primary'
                      disabled={isSubmitting}
                    >
                      Solicitar
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    )
  }
}

export default ForgotPassword
